import { DiscountType } from "./types";
import { DiscountAmountType, DiscountWriteModel } from "../../models/Discount";

export const isPeriodicDiscount = (
  type: number = 0,
  discountTypes: ReadonlyArray<DiscountType>
) =>
  getDiscountType(type, discountTypes)?.id === 2 ||
  getDiscountType(type, discountTypes)?.id === 3;

export const isScannableDiscount = (
  type: number = 0,
  discountTypes: ReadonlyArray<DiscountType>
) => getDiscountType(type, discountTypes)?.id === 0;

export const isSinglePurchaseDiscount = (
  type: number = 0,
  discountTypes: ReadonlyArray<DiscountType>
) => getDiscountType(type, discountTypes)?.id === 1;

export const getDiscountType = (
  typeId: number,
  discountTypes: ReadonlyArray<DiscountType>
): DiscountType | undefined => discountTypes.find(type => type.id === typeId);

const codeRegEx = new RegExp("^[\\w-{}]+$");

export const isValidCode = (code: string | undefined) =>
  code === "" || !!code?.match(codeRegEx);

export const isValidName = (name: string | undefined) =>
  !!name && name.length >= 1;

export const isValidAmount = (
  amount: number | undefined,
  amountType: DiscountAmountType = "Percentage"
) => {
  if (amount === undefined) {
    return false;
  } else if (amountType === "Percentage") {
    return amount > 0 && amount <= 100;
  } else {
    return amount > 0;
  }
};

export const isValidMinimumAmount = (
  discount: DiscountWriteModel,
  discountTypes: ReadonlyArray<DiscountType>
) => {
  if (isPeriodicDiscount(discount.type, discountTypes)) {
    return (
      discount.minimumPurchaseAmount !== undefined &&
      discount.minimumPurchaseAmount > 0
    );
  }
  return true;
};

export const isValidAmountType = (amountType: any | undefined) => !!amountType;
export const isValidStartDate = (start: Date | undefined) => !!start;
export const isValidEndDate = (end: Date | undefined) => !!end;

export const isValidDiscount = (
  discount: DiscountWriteModel,
  discountTypes: ReadonlyArray<DiscountType>
): boolean => {
  if (discount.type === 0 && !isValidCode(discount.code)) return false;

  if (!isValidName(discount.name)) return false;
  if (!isValidAmount(discount.amount, discount.amountType || "Percentage"))
    return false;
  if (!isValidAmountType(discount.amountType)) return false;

  if (!isValidMinimumAmount(discount, discountTypes)) {
    return false;
  }

  if (!isPeriodicDiscount(discount.type, discountTypes)) {
    if (discount.type !== 0 && !discount.handoutType) return false;
    if (!isValidStartDate(discount.start)) return false;
    if (!isValidEndDate(discount.end)) return false;
  }
  return true;
};
